module.exports = __webpack_public_path__ + "img/logo_icon.5dfd0701.png";